<div class="upcoming-block" *ngIf="occurrence">
  <div class="personal-block">
    <div class="avatar-block" *ngIf="occurrence.student" routerLink="../trainings/detail/{{formationId}}/info">
      <div class="avatar-inset-shadow"></div>
      <img class="user-avatar" src="{{defaultAvatar}}" *ngIf="occurrence.student.user.photo_profile === null">
      <img class="user-avatar" src="{{occurrence.student.user.photo_profile.thumbnail_150}}"
        *ngIf="occurrence.student.user.photo_profile !== null">
    </div>
    <div class="student-label">
      <div class="timeinfo">{{occurrence.start | amLocale: 'en' | amLocale: 'en' | amDateFormat:'ddd DD MMM'}},
        {{occurrence.start | amLocale: 'en'| amLocale: 'en' | amDateFormat:'HH:mm'}} - {{occurrence.end | amLocale: 'en'
        | amDateFormat:'HH:mm'}}</div>
      <div class="student-name">{{occurrence.student.user.first_name}} {{occurrence.student.user.last_name}}</div>
    </div>
    <div class="actions-wrapper">
      <div class="accept-btn" (click)="setRecheduleRequest('accepted')" translate>reschedule.request.btn.accept</div>
      <div class="refused-btn" (click)="setRecheduleRequest('refused')" translate>reschedule.request.btn.refused</div>
    </div>
  </div>
  <div class="personal-block cancelled_message">
    <span class="subtitle " translate>reschedule.request.cancel.reason </span>
    <span>
      {{getLabelByCode(occurrence.cancelled_reason)}}
    </span>
  </div>
  <div class="personal-block cancelled_message">
    <span class="subtitle " translate>reschedule.request.cancel.message </span>
    <span>
      {{occurrence.cancelled_message}}
    </span>
  </div>
</div>
<mat-spinner *ngIf="loading" class="loader">
</mat-spinner>